var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cancel-step-wrapper"},[(_vm.cancelAccountLoading)?_c('spinner'):_vm._e(),_c('h2',{staticClass:"title larger"},[_vm._v(_vm._s(_vm.$t('confirmation_cancel_account_title')))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t('confirmation_cancel_account_subtitle')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }